import axios from 'axios'
import useSWR from 'swr'

export const useAppVersion = () => {
  const { data, error, isLoading } = useSWR('/api/version', async () => {
    const { data } = await axios.get<{ version: string }>('/api/version')

    return data.version
  })

  return { data, error, isLoading }
}
